// Quit Smoking uses Spending's shared class strings (44px targets, 3px focus ring, 24px cards);
// AppShell already gives the 16px side gutter and the room above the bottom nav.
import { FOCUS } from '../spending/styles';

export { CARD, FOCUS, H1, INPUT, LABEL, QUIET_LINK, SCREEN } from '../spending/styles';

export const H2 = 'text-xl font-bold text-fg';
/** The big count (design.md: DM Mono for numbers). */
export const HERO_NUM = 'font-mono tabular-nums text-[48px] leading-none text-fg';
export const PILL_BTN = `inline-flex min-h-11 items-center justify-center rounded-full bg-secondary px-4 text-sm font-medium text-fg hover:bg-[var(--hover-strong)] ${FOCUS}`;
